export const PRIZES = [
  37500,
  33000,
  28500,
  27000,
  24000,
  ...Array(15).fill(20000),
  ...Array(180).fill(5833),
];

export const getRankingPrizes = (getsRewards: boolean[]): Array<number | undefined> => {
  let prizeIndex = 0;

  return getsRewards.map((getsReward) => getsReward ? PRIZES[prizeIndex++] : undefined);
};
